import {Component, inject, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {CompanyService} from '@services/company.service';
import {UserStateService} from '@services/frontend/user-state.service';
import {Role, UserDetailsResponse} from '@models/user.interface';
import {UserService} from '@services/user.service';
import {ExpertPaymentService} from '@services/expert-payment.service';

@Component({
    selector: 'app-dashboard-entry-redirect',
    template: '',
})
export class DashboardEntryRedirect implements OnInit {

  private readonly userService = inject(UserService);
  private readonly companyService = inject(CompanyService);
  private readonly expertPaymentService = inject(ExpertPaymentService);
  private readonly router = inject(Router);
  private readonly userStateService = inject(UserStateService);

  ngOnInit(): void {
    this.userService.me().subscribe({
      next: (user: UserDetailsResponse) => {
        this.userStateService.setUser(user);

        if (user?.role === Role.ACCOUNTANT || user?.role === Role.ADMIN) {
          this.navigateExpert(user);
          return;
        }

        this.companyService.getCompanies().subscribe({
          next: (companies) => {
            const firstCompany = companies[0];
            if (!firstCompany) {
              void this.router.navigate(['/dashboard', 'overview']);
              return;
            }
            void this.router.navigate(['/dashboard', 'company', firstCompany.siret, 'tableau-de-bord']);
          },
          error: () => {
            void this.router.navigate(['/dashboard', 'overview']);
          }
        });
      }
    });
  }

  private navigateExpert(user: UserDetailsResponse): void {
    if (user.role === Role.ADMIN) {
      void this.router.navigate(['/dashboard', 'expert', 'clients']);
      return;
    }

    this.expertPaymentService.checkExpertPayment().subscribe({
      next: (status) => {
        void this.router.navigate(
          status.paid
            ? ['/dashboard', 'expert', 'clients']
            : ['/dashboard', 'expert', 'paiement']
        );
      },
      error: () => void this.router.navigate(['/dashboard', 'expert', 'paiement']),
    });
  }
}
